import React, { useState } from 'react';
import { formatCode } from '../../utils/formatCode';

/**
 * "Beautify" for a Raw JSON / XML request body, next to the body type
 * pickers — where Postman puts it (owner, 30.09.2026: an XML body stayed one
 * long line; the body editor hides its chrome, so it had no Format button at
 * all). Uses the app's formatters (utils/formatCode → xmlFormat / formatJson);
 * a body that cannot be parsed is left exactly as typed, with a short note.
 */
// `.trim()` on a 10 MB body costs a full copy on every render (V8 flattens the
// string the editor built); a body that long is not blank.
const hasText = (value) => {
  const s = String(value || '');
  return s.length > 65536 || s.trim() !== '';
};

export default function BodyBeautifyButton({ language, value, onChange }) {
  const [failed, setFailed] = useState(false);
  if (language !== 'json' && language !== 'xml') return null;
  return (
    <span className="body-beautify">
      <button
        type="button"
        className="body-beautify__btn"
        disabled={!hasText(value)}
        onClick={() => {
          const result = formatCode(language, value);
          setFailed(!result.ok);
          if (result.ok && result.value !== value) onChange(result.value);
        }}
      >
        Beautify
      </button>
      {failed && (
        <span className="body-beautify__note" role="status">
          {language === 'xml' ? 'Could not format XML' : 'Could not format JSON'}
        </span>
      )}
    </span>
  );
}
